import * as React from 'react';

var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgTeamSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5h18",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.333A2.667 2.667 0 1012 6a2.667 2.667 0 000 5.333z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.333v-2.666A2.667 2.667 0 0110.667 14h2.666A2.667 2.667 0 0116 16.667v2.666",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.333v-2.666A2.667 2.667 0 0110.667 14h2.666A2.667 2.667 0 0116 16.667v2.666",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.333A2.667 2.667 0 1017 6c.167.278 1 1.2 1 2.667 0 1.466-.833 2.389-1 2.666zM20.22 14.781c-.501-.5-1.18-.781-1.886-.781.222.278.666 1.2.666 2.667v2.666h2v-2.666c0-.708-.28-1.386-.78-1.886zM7 11.333A2.667 2.667 0 117 6c-.167.278-1 1.2-1 2.667 0 1.466.833 2.389 1 2.666zM3.78 14.781c.501-.5 1.18-.781 1.887-.781-.223.278-.667 1.2-.667 2.667v2.666H3v-2.666c0-.708.28-1.386.78-1.886z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export { SvgTeamSolid as ReactComponent };
